import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseTaskMainSidenavComponent } from './sidenavs/main/main-sidenav.component';
import { FuseTaskDetailsComponent } from './task-details/task-details.component';
import { FuseTaskListItemComponent } from './task-list/task-list-item/task-list-item.component';
import { FuseTaskListComponent } from './task-list/task-list.component';
import { FuseTaskComponent } from './task.component';
import { TaskDialogComponent } from './task-dialog/task-dialog.component';
import { PhoenixPipesModule } from '../../../pipes/pipes';
import { ValidationErrorsModule } from '../../../components/validation-errors/validation-errors.module';
import { IntecDatePickerModule } from 'app/components/intec-date-picker2/intec-date-picker.module';
import { MailMergeWizardComponent } from './mail-merge-wizard/mail-merge-wizard/mail-merge-wizard.component';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FusePromptEmailDialogComponent } from './task-list/task-list-item/prompt-email-dialog/prompt-email-dialog.component';
import { CheckListComponentModule } from 'app/components/check-list/check-list.module';

const routes = [
  {
    path: 'all',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'all' },
  },
  {
    path: 'my',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'my' },
  },
  {
    path: 'users',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'filterByUser' },
  },
  {
    path: 'created',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'created' },
  },
  {
    path: 'created/:state',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'created' },
  },
  {
    path: 'all/:state',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'all' },
  },
  {
    path: 'my/:state',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'my' },
  },
  {
    path: 'users/:state',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'filterByUser' },
  },
  {
    path: 'users/:state/u/:users',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'users' },
  },


  {
    path: 'all/org/:org',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'all' },
  },
  {
    path: 'my/org/:org',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'my' },
  },
  {
    path: 'users/org/:org',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'filterByUser' },
  },
  {
    path: 'created/org/:org',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'created' },
  },
  {
    path: 'created/:state/org/:org',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'created' },
  },
  {
    path: 'all/:state/org/:org',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'all' },
  },
  {
    path: 'my/:state/org/:org',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'my' },
  },
  {
    path: 'users/:state/org/:org',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'filterByUser' },
  },
  {
    path: 'users/:state/u/:users/org/:org',
    exactMatch: true,
    component: FuseTaskComponent,
    data: { tasks: 'users' },
  },

  
  // {
  //     path     : 'all/:taskId',
  //     component: FuseTaskComponent,
  //     // resolve  : {
  //     //     task: TaskService,
  //     // },
  // },
  // {
  //     path     : 'tag/:tagHandle',
  //     component: FuseTaskComponent,
  //     // resolve  : {
  //     //     task: TaskService,
  //     // },
  // },
  // {
  //     path     : 'tag/:tagHandle/:taskId',
  //     component: FuseTaskComponent,
  //     // resolve  : {
  //     //     task: TaskService,
  //     // },
  // },
  // {
  //     path     : 'filter/:filterHandle',
  //     component: FuseTaskComponent,
  //     // resolve  : {
  //     //     task: TaskService,
  //     // },
  // },
  // {
  //     path     : 'filter/:filterHandle/:taskId',
  //     component: FuseTaskComponent,
  //     // resolve  : {
  //     //     task: TaskService,
  //     // },
  // },
];

@NgModule({
  declarations: [
    FuseTaskComponent,
    FuseTaskMainSidenavComponent,
    FuseTaskListItemComponent,
    FuseTaskListComponent,
    FusePromptEmailDialogComponent,
    FuseTaskDetailsComponent,
    TaskDialogComponent,
    MailMergeWizardComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    IntecDatePickerModule,
    ValidationErrorsModule,
    PhoenixPipesModule.forRoot(),
    PhoenixDirectivesModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    MatDividerModule,
    MatSlideToggleModule,
    MatSidenavModule,
    MatTableModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatSortModule,
    MatTabsModule,
    MatToolbarModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatMenuModule,
    CheckListComponentModule,
    FuseSharedModule,
    ScrollingModule,
  ],
  exports: [
    FuseTaskDetailsComponent,
    FuseTaskListComponent,
    FuseTaskComponent,
    FusePromptEmailDialogComponent,
    FuseTaskListItemComponent,
    FuseTaskMainSidenavComponent,
    TaskDialogComponent,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FuseTaskModule {}
